import { memo, useRef } from 'react';
import type { CSSProperties } from 'react';
import type { ResizeControlPosition, ResizeLimits } from '../../core';
import { useResizeControl } from '../../interactions';
import type { ResizeCallbacks } from '../../interactions';
import { classNames } from '../../utils';

export type ResizeControlVariant = 'line' | 'handle';

export type ResizeControlProps = ResizeCallbacks & {
  nodeId: string | null;
  position: ResizeControlPosition;
  variant: ResizeControlVariant;
  limits: ResizeLimits;
  color?: string;
  className?: string;
  style?: CSSProperties;
};

/** One side line or corner handle of a `NodeResizer` (v11 classes; `nodrag` keeps node dragging out of it). */
const ResizeControlComponent = ({ nodeId, position, variant, limits, color, className, style, ...callbacks }: ResizeControlProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useResizeControl(ref, nodeId, position, limits, callbacks);
  const colorStyle = color ? { [variant === 'line' ? 'borderColor' : 'backgroundColor']: color } : {};
  return (
    <div
      ref={ref}
      className={classNames('cm-resize-control', 'nodrag', ...position.split('-'), variant, className)}
      style={{ ...style, ...colorStyle }}
    />
  );
};

export const ResizeControl = memo(ResizeControlComponent);
